import { ReactElement, HTMLAttributes } from 'react';

import {
  MarketAccessory,
  MarketContentCard,
  MarketButton,
  MarketRow,
} from '@market/react';

import styles from 'typescript/apps/checkout_v3/components/condensed_info/condensed_info.module.scss';
import { CondensedInfoDetails } from 'typescript/apps/checkout_v3/components/condensed_info/types';

interface CondensedInfoProps extends HTMLAttributes<HTMLElement> {
  condensedInfoDetails?: CondensedInfoDetails;
  leadingAccessory?: ReactElement;
  trailingAccessory?: ReactElement;
  onTrailingAccessoryClick?: () => void;
  sideLabel?: string;
  disableTrailingAccessory?: boolean;
}

const CondensedInfo = ({
  className,
  condensedInfoDetails,
  trailingAccessory,
  onTrailingAccessoryClick,
  sideLabel,
  disableTrailingAccessory = false,
}: CondensedInfoProps) => {
  const { leadingAccessory, header, paragraphs } = condensedInfoDetails;

  return (
    <MarketContentCard className={`${styles.condensedInfoCard} ${className}`}>
      <MarketRow>
        {leadingAccessory && (
          <MarketAccessory className={styles.icon} slot="leading-accessory">
            {leadingAccessory}
          </MarketAccessory>
        )}
        <label slot="label">
          <div className={styles.paragraphHeader}>{header}</div>
          {paragraphs.map((paragraph, i) => (
            <p key={`condensed-paragraph-${i}`}>{paragraph}</p>
          ))}
        </label>
        {sideLabel && <label slot="side-label">{sideLabel}</label>}
        {trailingAccessory && (
          <MarketButton
            disabled={disableTrailingAccessory}
            rank="tertiary"
            slot="trailing-accessory"
            onClick={onTrailingAccessoryClick}
          >
            <MarketAccessory slot="icon">{trailingAccessory}</MarketAccessory>
          </MarketButton>
        )}
      </MarketRow>
    </MarketContentCard>
  );
};

export default CondensedInfo;
